import React, {useMemo} from 'react';
import {QrCodeIcon} from '@heroicons/react/24/outline';
import {useEditor} from '@craftjs/core';
import {useEditorDevice} from 'hooks';

import EditorToolbox from '../../toolboxes/Editor.Toolbox';
import EditorContentQR from './Editor.Content.QR';

interface IEditorToolboxQRProps {}

const EditorToolboxQR = ({}: IEditorToolboxQRProps) => {
  const device = useEditorDevice();
  const {nodes, query} = useEditor(state => ({
    nodes: state.nodes,
  }));

  const hasNode = useMemo(() => {
    return query.serialize().includes('EditorContentQR');
  }, [nodes, query]);

  const disabled = device === 'mobile' || hasNode;

  return (
    <EditorToolbox
      key={`${disabled}`}
      icon={<QrCodeIcon />}
      text="QR Code"
      info="This component is desktop only"
      disabled={disabled}
      showExclamation={!hasNode}>
      <EditorContentQR />
    </EditorToolbox>
  );
};

export default React.memo(EditorToolboxQR);
